import { Injectable } from "@angular/core";

interface PathLocation {
    id: PATHS;
    path: string;
    location: string;
    mainPath?: boolean;
};

export enum PATHS {
    ROOT = 'root',
    LOGIN = 'login',
    FORGOT = 'forgot',
    CHANGE = 'change',
    NOT_FOUND = '404',
    ADMIN = 'admin',
    PROPERTY = 'property',
    FACILITY = 'facility',
    PROJECTS = 'projects',
    FINANCIAL = 'financial',
    CLIENTS = 'clients',
    TRAININGS = 'trainings',
    REPORTS = 'reports',
};

export enum PROCESS_SERVICE_STATES {
    waiting = 'waiting',
    inProgress = 'in_progress',
    done = 'done'
};

export enum REQUEST_STATUSES {
    error = 1,
    success = 0
};

export enum ERRORS {
    malformedRequest = 'malformed_request'
};

export enum LOCAL_STORAGE_KEYS {
    token = 'token',
};

/**
 * Am decis sa declar toate pathurile copiilor fiecarei rute, pentru a putea accesa in mod direct fara alte verificari
 * Astfel, daca am nevoie de un path, pot sa il accesez direct din PATH_LOCATIONS.children[PATHS.LOGIN].path
 */
export type RootPath = PATHS.LOGIN | PATHS.FORGOT | PATHS.CHANGE | PATHS.NOT_FOUND | PATHS.ADMIN | PATHS.PROPERTY | PATHS.FACILITY | PATHS.PROJECTS | PATHS.FINANCIAL | PATHS.CLIENTS | PATHS.TRAININGS | PATHS.REPORTS;

type PathLocationChildren = {
    /* [K in (RootPath | OtherPath)]: PathLocation | PathLocationWithChildren; */
    [K in RootPath]: PathLocation | PathLocationWithChildren;
};

interface PathLocationWithChildren extends PathLocation {
    children: PathLocationChildren;
}

export const EVENTS = {
    languageChanged: 'languageChanged',
};

export const PATH_LOCATIONS: PathLocationWithChildren = {
    id: PATHS.ROOT,
    path: '/',
    location: '/',
    children: {
        [PATHS.LOGIN]: {
            id: PATHS.LOGIN,
            path: `/${PATHS.LOGIN}`,
            location: `/${PATHS.LOGIN}`,
        },
        [PATHS.FORGOT]: {
            id: PATHS.FORGOT,
            path: `/${PATHS.FORGOT}`,
            location: `/${PATHS.FORGOT}`,
        },
        [PATHS.CHANGE]: {
            id: PATHS.CHANGE,
            path: `/${PATHS.CHANGE}`,
            location: `/${PATHS.CHANGE}`,
        },
        [PATHS.NOT_FOUND]: {
            id: PATHS.NOT_FOUND,
            path: `/${PATHS.NOT_FOUND}`,
            location: `/${PATHS.NOT_FOUND}`,
        },
        [PATHS.ADMIN]: {
            id: PATHS.ADMIN,
            path: `/${PATHS.ADMIN}`,
            location: `/${PATHS.ADMIN}`,
        },
        [PATHS.PROPERTY]: {
            id: PATHS.PROPERTY,
            path: `/${PATHS.PROPERTY}`,
            location: `/${PATHS.PROPERTY}`,
        },
        [PATHS.FACILITY]: {
            id: PATHS.FACILITY,
            path: `/${PATHS.FACILITY}`,
            location: `/${PATHS.FACILITY}`,
        },
        [PATHS.PROJECTS]: {
            id: PATHS.PROJECTS,
            path: `/${PATHS.PROJECTS}`,
            location: `/${PATHS.PROJECTS}`,
        },
        [PATHS.FINANCIAL]: {
            id: PATHS.FINANCIAL,
            path: `/${PATHS.FINANCIAL}`,
            location: `/${PATHS.FINANCIAL}`,
        },
        [PATHS.CLIENTS]: {
            id: PATHS.CLIENTS,
            path: `/${PATHS.CLIENTS}`,
            location: `/${PATHS.CLIENTS}`,
        },
        [PATHS.TRAININGS]: {
            id: PATHS.TRAININGS,
            path: `/${PATHS.TRAININGS}`,
            location: `/${PATHS.TRAININGS}`,
        },
        [PATHS.REPORTS]: {
            id: PATHS.REPORTS,
            path: `/${PATHS.REPORTS}`,
            location: `/${PATHS.REPORTS}`,
        }
    }
};

export const MAIN_PATHS = new Set([
    PATHS.ADMIN,
]);

export const LOCALIZATION_PATH = './localization';
export const ICONS_PATH = './global/ux/icons';

@Injectable({
    providedIn: 'root'
})

export class ValuesService {
    public readonly ICONS_PATH = ICONS_PATH;
}